import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useCreateFacilitation } from './api'
import { formSchema } from './schema'
import FormBuilder from '../../../../components/app/formBuilder'
import { Button } from '../../../../components/common'

import { facilitationFormFields } from './data'

export default function FacilitationForm() {
  const methods = useForm({
    resolver: zodResolver(formSchema),
    mode: 'onChange',
  })

  const { handleSubmit } = methods
  const { mutate } = useCreateFacilitation(onSuccess)

  function onSuccess() {
    methods.reset()
    window.location.reload()
  }

  const onSubmit = (data: any) => {
    const formData = new FormData()

    formData.append('gender', data.gender)
    formData.append('social_category', data.social_category)
    formData.append('age', data.age)
    formData.append('attended_kied_training', data.attended_kied_training)
    formData.append('training_names', data.training_names)
    formData.append('training_period', data.training_period)
    formData.append('enterprise_name', data.enterprise_name)
    formData.append('enterprise_address', data.enterprise_address)
    formData.append('business_type', data.business_type)
    formData.append('business_activity', data.business_activity)
    formData.append('products_or_services', data.products_or_services)
    formData.append('service_type', data.service_type)
    formData.append('service_description', data.service_description)
    formData.append('uploaded_document', data.uploaded_document)

    mutate(formData)
  }

  return (
    <div className="w-11/12 mx-auto py-10">
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-10 bg-white p-8 rounded-lg"
        >
          <div className="mb-8">
            <h2 className="text-lg font-semibold">Contact Information</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <FormBuilder data={facilitationFormFields} edit />
            </div>
          </div>

          <div className="flex justify-end">
            <Button
              type="submit"
              className="bg-white0 text-white px-6 py-2 rounded"
              label="Submit Application"
            />
          </div>
        </form>
      </FormProvider>
    </div>
  )
}
